// extracted by mini-css-extract-plugin
export default {"commonPasswordAlert":"registration-forms_commonPasswordAlert__MgMtM"};